import Vue from 'vue'
import Router from 'vue-router'
import Config from 'src/config'
import Intro from 'components/Intro'
import Page from 'components/Page'
import Collections from 'components/Collections'
import Collection from 'components/Collection'
import CollectionItem from 'components/CollectionItem'
import CollectionItems from 'components/Collection__SKUs'
import NotesPane from 'components/NotesPane'
import Purchase from 'components/Purchase'

// import imagesLoaded from 'imagesloaded'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Intro',
      component: Intro,
      meta: { hideFooter: true },
      children: [
        {
          path: 'notes',
          name: 'Notes',
          component: NotesPane,
          meta: { hideFooter: true }
        }
      ]
    },
    {
      path: '/collections',
      name: 'Collections',
      component: Collections
    },
    {
      path: '/collections/:slug/items',
      name: 'Collection Items',
      component: CollectionItems,
      props: true,
      meta: {
        updateMetaTitle: true
      },
      children: [
        {
          path: ':id',
          name: 'Collection Items – Item Overlay',
          component: CollectionItem,
          props: true,
          meta: {
            isOverlay: true
          }
        }
      ]
    },
    {
      path: '/collections/:slug',
      name: 'Collection',
      component: Collection,
      props: true,
      children: [
        {
          path: 'item/:id',
          name: 'Collection - Item Overlay',
          component: CollectionItem,
          props: true,
          meta: {
            isOverlay: true,
            hide360Images: true
          }
        }
      ]
    },

    {
      path: '/purchase',
      name: 'Purchase',
      component: Purchase,
      props: true
    },

    {
      path: '/login',
      redirect: to => {
        window.location.replace(Config.prismic.login)
        return false
      }
    },
    {
      path: '/:slug',
      name: 'Page',
      component: Page,
      props: true
    },
    {
      path: '*',
      name: '404',
      component: Page,
      props: true
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js